export default __webpack_public_path__ + "static/media/marker.19adcd2d.svg";